export const NONE = 'NONE';
export const SELECTIVE = 'SELECTIVE';
export const ALL = 'ALL';